/**
 * Lokaal dev: links die je deelt (QR voor de telefoon, cliëntlink) werken niet
 * met `localhost` op een ander apparaat. Vite geeft het Tailscale-adres van deze
 * machine mee; in productie is de waarde leeg en verandert er niets.
 */
declare const __DEV_SHARE_HOST__: string;

const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "[::1]"]);

export function withShareHost(href: string, shareHost: string): string {
  if (!shareHost) return href;
  const url = new URL(href);
  if (!LOCAL_HOSTNAMES.has(url.hostname)) return href;
  url.hostname = shareHost;
  return url.toString();
}

/** Adres van deze pagina zoals een ander apparaat het kan openen. */
export function shareableHref(href: string = location.href): string {
  return withShareHost(href, typeof __DEV_SHARE_HOST__ === "string" ? __DEV_SHARE_HOST__ : "");
}
